import createVueComponent from '../createVueComponent';

const ArrowDownFromLine = createVueComponent('ArrowDownFromLineIcon', [
  ['path', { d: 'M19 3H5', key: '1236rx' }],
  ['path', { d: 'M12 21V7', key: 'gj6g52' }],
  ['path', { d: 'm6 15 6 6 6-6', key: 'h15q88' }],
]);

export default ArrowDownFromLine;
